import { getDataWithParams } from 'src/consumer/services/profileService'

export const TIMERS_OBJECT_UNLIMITED = {
  apiParam: 'technique-response',
  id: 'MED-b0a4e4c1fc0e417e907eb74582506e1b',
  enabled: true,
  deleted: false,
  idByUser: false,
  createdTime: '2023-10-21 08:26:01',
  modifiedTime: '2023-10-22 14:59:51',
  title: 'Art Therapy',
  description:
    'Unleash your inner artist! Art therapy lets you express feelings through creative mediums, turning emotions into beautiful masterpieces.',
  subscription: { id: 'subscription_normal', name: 'Premium' },
  altTexts: {},
  shortDescription: 'Paint your emotions.',
  status: 'published',
  approvedBy: 'USR-a5fc39fe84ab4f21b5085406290e71d0',
  type: 'online_guided',
  steps: {
    preInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    preparatory: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    meditate: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: true,
    },
    postInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    feedback: { mandatory: true, enabled: true },
    result: { mandatory: true, enabled: true },
    actions: { mandatory: true, enabled: true },
    notes: { mandatory: true, enabled: true },
  },
  featuredMeditation: false,
  verified: false,
  approvedAt: '2023-10-22 14:59:48',
  noOfTimeCopied: 0,
  durationType: 'unlimited',
  minDuration: 0,
  maxDuration: 0,
  sadhana: false,
  mandala: false,
  videos: [{ defaultVideo: false, enabled: true, hls: {}, youtube: {} }],
  favorite: false,
  source: 'school',
  favCount: 0,
  bellType: 'bell',
  publicMeditation: false,
  hasCourse: false,
  popularity: 0,
  primaryLanguage: 'en',
  translations: {},
  liveCount: 0,
  trackCount: 0,
  trackCreated: false,
  trackPublished: false,
  completedMandala: 0,
  itemType: 'technique',
  duration: 0,
  appLanguages: ['en'],
  appLanguageInTxt: 'en',
}

export const TIMERS_OBJECT = {
  apiParam: 'technique',
  id: 'MED-d395cc59270f4caf9e1b599eb732da2e',
  enabled: true,
  deleted: false,
  idByUser: false,
  slug: 'heartfulness-cleaning',
  apiParam: 'technique',
  createdTime: '2021-03-20 19:09:54',
  modifiedTime: '2021-08-29 19:11:19',
  title: 'Heartfulness Cleaning',
  description:
    'Cleaning fosters lightness of being, joy and a carefree attitude, as emotional burdens, habits, deep conditioning and complexities are removed.',
  coverIcon: 'MEDIA-a9d3341fb651464ba8ebf1a41e4493da',
  coverImage: 'MEDIA-5240991191d24bdd8174d2479679c986',
  altTexts: {},
  shortDescription:
    'Cleaning fosters lightness of being, joy and a carefree attitude, as emotional burdens, habits, deep conditioning and complexities are removed.',
  mandalaPeriod: 40,
  status: 'draft',
  approvedBy: 'USR-169e2b17fde042e39ca7ffb0e70080e5',
  type: 'online_guided',
  steps: {
    preInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    preparatory: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    meditate: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: true,
    },
    postInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    feedback: { mandatory: true, enabled: true },
    result: { mandatory: true, enabled: true },
    actions: { mandatory: true, enabled: true },
    notes: { mandatory: true, enabled: true },
  },
  featuredMeditation: false,
  verified: true,
  approvedAt: '2021-08-13 19:22:54',
  noOfTimeCopied: 0,
  durationType: 'fixed',
  minDuration: 1200000, //this is in milliseconds
  maxDuration: 0, //this is in milliseconds
  sadhana: true,
  mandala: true,
  videos: [{ defaultVideo: false, enabled: true, hls: {}, youtube: {} }],
  favorite: false,
  source: 'school',
  difficultyLevel: { level: 'Beginner', order: 1 },
  favCount: 0,
  bellType: 'bell',
  publicMeditation: true,
  hasCourse: true,
  popularity: 0,
  primaryLanguage: 'en',
  translations: {
    en: {
      title: 'Heartfulness Cleaning',
      shortDesc:
        'Cleaning fosters lightness of being, joy and a carefree attitude, as emotional burdens, habits, deep conditioning and complexities are removed.',
      longDesc:
        'Cleaning fosters lightness of being, joy and a carefree attitude, as emotional burdens, habits, deep conditioning and complexities are removed.',
      videos: [{ defaultVideo: false, enabled: true, hls: {}, youtube: {} }],
    },
    ru: { title: 'Чистка душевности' },
    hi: { title: 'हार्टफुलनेस क्लीनिंग' },
    te: { title: 'హృదయపూర్వక శుభ్రపరచడం' },
    tr: { title: 'gönül temizliği' },
    pl: { title: 'gönül temizliği' },
    bn: { title: 'আন্তরিকতা পরিষ্কার' },
    zh: { title: '用心清洁' },
    da: { title: 'Heartfulness Rengøring' },
    de: { title: 'Herzhafte Reinigung' },
    gu: { title: 'હાર્દિકની સફાઇ' },
    kn: { title: 'ಹೃತ್ಪೂರ್ವಕ ಶುಚಿಗೊಳಿಸುವಿಕೆ' },
    es: { title: 'Limpieza Heartfulness' },
    th: { title: 'ทำความสะอาดหัวใจ' },
    ur: { title: 'دل کی صفائی' },
    ta: { title: 'இதயத்தை சுத்தம் செய்தல்' },
    sv: { title: 'Hjärtlig rengöring' },
    nl: { title: 'Hartelijke reiniging' },
    cs: { title: 'Srdečné čištění' },
    fil: { title: 'Paglilinis ng Puso' },
    fr: { title: 'Nettoyage Heartfulness' },
    ka: { title: 'გულის სიწმინდე' },
    ml: { title: 'ഹാർട്ട്ഫുൾനെസ് ക്ലീനിംഗ്' },
    ms: { title: 'Pembersihan Hati' },
    mr: { title: 'मनापासून स्वच्छता' },
    ne: { title: 'हार्दिक सफाई' },
    id: { title: 'Pembersihan Hati' },
    it: { title: 'Pulizia del cuore' },
    ko: { title: '진심 어린 청소' },
    ja: { title: '心のこもった掃除' },
    sk: { title: 'Srdečné čistenie' },
    pt: { title: 'Limpeza de Heartfulness' },
    pa: { title: 'ਦਿਲ ਦੀ ਸਫਾਈ' },
    hy: { title: 'Սրտանց մաքրում' },
    ar: { title: 'تنظيف القلب' },
    no: { title: 'Hjertelig rengjøring' },
    mk: { title: 'Чистење на срцето' },
    fi: { title: 'Sydämellinen puhdistus' },
    et: { title: 'Südamlikkuse puhastamine' },
    el: { title: 'Καθαρισμός εγκληματικότητας' },
    or: { title: 'ହୃଦୟ ସଫା କରିବା |' },
    sr: { title: 'Срдачност Чишћење' },
    fa: { title: 'تمیز کردن قلب' },
    sin: { title: 'හදවත් පිරිසිදු කිරීම' },
  },
  itemType: 'technique',
  duration: 1200000,
}

export const TIMERS_OBJECT_EMPTY = {
  apiParam: 'technique',
  id: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  apiParam: 'technique',
  title: 'My Timer',
  altTexts: {},
  intervals: [],
  type: 'online_guided',
  steps: {
    preInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    preparatory: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    meditate: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: true,
    },
    postInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    feedback: { mandatory: true, enabled: true },
    result: { mandatory: true, enabled: true },
    actions: { mandatory: true, enabled: true },
    notes: { mandatory: true, enabled: true },
  },
  featuredMeditation: false,
  verified: true,
  noOfTimeCopied: 0,
  durationType: 'fixed',
  sadhana: true,
  mandala: false,
  favorite: false,
  bellType: 'bell',
  publicMeditation: true,
  hasCourse: true,
  popularity: 0,
  primaryLanguage: 'en',
  itemType: 'technique',
  duration: 300000, // 5 mins
  minDuration: 300000, // 5 mins
  maxDuration: 360000,
}

export const TIMERS_OBJECT_RANGE = {
  apiParam: 'technique-response',
  id: 'MED-60ed808811d04875a28867d5cff05750',
  enabled: true,
  deleted: false,
  idByUser: false,
  apiParam: 'technique-response',
  createdTime: '2024-02-20 10:07:19',
  modifiedTime: '2024-03-11 16:52:38',
  title: 'Hello',
  description: 'long desc',
  subscription: { name: 'Premium' },
  altTexts: {},
  tags: ['soul_deepen_my_practice'],
  shortDescription: 'short desc',
  mandalaPeriod: 3,
  status: 'draft',
  type: 'online_guided',
  steps: {
    preInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    preparatory: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    meditate: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: true,
    },
    postInstructions: {
      enabled: false,
      track: { duration: 0.0 },
      mandatory: true,
      trackEditable: true,
      recording: false,
    },
    feedback: { mandatory: true, enabled: true },
    result: { mandatory: true, enabled: true },
    actions: { mandatory: true, enabled: true },
    notes: { mandatory: true, enabled: true },
  },
  featuredMeditation: false,
  verified: false,
  noOfTimeCopied: 0,
  durationType: 'range',
  minDuration: 180000,
  maxDuration: 300000,
  sadhana: true,
  mandala: true,
  videos: [{ defaultVideo: false, enabled: true, hls: {}, youtube: {} }],
  favorite: false,
  source: 'school',
  difficultyLevel: { level: 'Advanced', order: 2 },
  favCount: 0,
  bellType: 'bell',
  publicMeditation: false,
  hasCourse: false,
  popularity: 0,
  primaryLanguage: 'en',
  translations: {
    en: {
      title: 'Hello',
      shortDesc: 'short desc',
      longDesc: 'long desc',
      videos: [{ defaultVideo: false, enabled: true, hls: {}, youtube: {} }],
    },
  },
  liveCount: 0,
  trackCount: 0,
  trackCreated: false,
  trackPublished: false,
  completedMandala: 0,
  itemType: 'technique',
  duration: 180000,
  appLanguages: ['en'],
  appLanguageInTxt: 'en',
}

export async function getPracticeTimerById(id) {
  const response = await getDataWithParams(`/api/secure/meditations/${id}`, {})
  if (response.status === 200) {
    return response
  }
  return TIMERS_OBJECT
}

export async function getPracticeTimerBySlug(slug) {
  // const response = await getDataWithParams(`/api/secure/meditations/${slug}`, {})
  // if (response.status === 200) {
  //   return response
  // }
  return TIMERS_OBJECT
}
